/* eslint-disable @typescript-eslint/no-use-before-define */
import countryList from "react-select-country-list";
import { SocialNetwork } from "../../../../Types";
import { useEffect, useState, useRef, useMemo } from "react";
import useDeviceType from "components/hooks/useDeviceType";
import PageHeader from "components/PageHeader";
import FilterBar from "components/FilterBar";
import place_holder from "assets/img/drag_placholder.png";
import clock_profile from "assets/img/klydoclock_profile.png";
import { roles } from "../../../../Types";
import { extractApiErrorMessage, statesList } from "../../../../utils/util";
import UserModal from "./UserModal";
import anonymousPhoto from "assets/img/anonymous.png";
import SocialNetworkEdit from "components/Widgets/SocialNetworkEdit";
import Editable from "components/Widgets/Editable";
import useUsers from "components/hooks/useUsers";
import useCreateUserMutation from "../hooks/useCreateUserMutation";
import useCreateClockMutation from "../hooks/useCreateClockMutation";
import DeleteUserModal from "./DeleteUserModal";
import useUpdateUserMutation from "../hooks/useUpdateUserMutation";
import { useSearchParams } from "react-router-dom";
import { User, UserType } from "../../../../api/admin";
import { Author } from "../../../../api/author";
import { DSBaseTable, DSTableCell } from "views/system-design/Table";
import { Column } from "views/system-design/Table/DSBaseTable/components/DSBaseTable";
import DSDialog from "views/system-design/DSDialog";
import DSDialogTitle from "views/system-design/DSDialogTitle";
import DSDialogContent from "views/system-design/DSDialogContent";
import DSTextField from "views/system-design/DSTextField";
import DSBox from "views/system-design/DSBox";
import DSTypography from "views/system-design/DSTypography";
import DSMenuItem from "views/system-design/DSMenuItem";
import DSPrimaryButton from "views/system-design/DSPrimaryButton";
import DSCircularProgress from "views/system-design/DSCircularProgress";
import DSAlert from "views/system-design/DSAlert";
import DSCheckBox from "views/system-design/DSCheckBox";
import DSFormControlLabel from "views/system-design/DSFormControlLabel";
import DSIconButton from "views/system-design/DSIconButton";
import CloseIcon from "@mui/icons-material/Close";

export const descriptionMaxLength = 420;

const tableColumns: Column<Author>[] = [
  { field: "name", label: "Name", sortable: true },
  { field: "email", label: "Email", sortable: true },
  { field: "role", label: "Role", sortable: true },
  { field: "createdAt", label: "Joined", sortable: true },
  { field: "id", label: "ID", sortable: true },
  { field: "photoUrl", label: "Pic" },
  { field: "tag", label: "Tag", sortable: true },
  { field: "featured", label: "Featured", sortable: true },
  { field: "klydoCount", label: "# Klydos", sortable: true },
  { field: "clocks", label: "# Clocks" },
];

function Users() {
  const { isSmallTablet } = useDeviceType();
  const [artistsOnly, setArtistsOnly] = useState(false);
  const [hasClockOnly, setHasClockOnly] = useState(false);
  const [manualPayoutOnly, setManualPayoutOnly] = useState(false);
  const [hasCollectionOnly, setHasCollectionOnly] = useState(false);
  const { data, isLoading } = useUsers(
    manualPayoutOnly || hasClockOnly || hasCollectionOnly
      ? {
          manualPayout: manualPayoutOnly,
          hasClock: hasClockOnly,
          hasCollection: hasCollectionOnly,
        }
      : undefined,
  );
  const [showAdd, setShowAdd] = useState(false);
  const [chosenUser, setChosenUser] = useState<Author | undefined>(undefined);
  const [userToDelete, setUserToDelete] = useState<Author | null>(null);
  const [validated, setValidated] = useState(false);
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [description, setDescription] = useState("");
  const [socialNetworkList, setSocialNetworkList] = useState<SocialNetwork[]>(
    [],
  );
  // Opens a CollabPay collaborator alongside the user. Brand accounts that will
  // own marketplace collections need one — the publication pass skips a
  // collection whose creator has no collaboratorId.
  const [createCollaborator, setCreateCollaborator] = useState(false);
  const [collaboratorWarning, setCollaboratorWarning] = useState<string | null>(
    null,
  );
  const [searchParams] = useSearchParams();
  const [searchQuery, setSearchQuery] = useState(
    searchParams.get("search") || "",
  );
  const [sortState, setSortState] = useState<Record<string, 1 | -1>>({});

  const successfulAdditionCallback = () => {
    resetAll();
    setValidated(true);
  };
  const userAddedCallback = (createdUser: User) => {
    if (createCollaborator && !createdUser.metadata?.collaboratorId) {
      setCollaboratorWarning(
        `${createdUser.email} was created, but opening its CollabPay collaborator failed. Retry from the user's modal — until then the marketplace publication pass will skip its collections.`,
      );
    }
    successfulAdditionCallback();
  };
  const failedAdditionCallBack = (e: unknown) => {
    setLoading(false);
    console.log("e:", e);
    setError({
      name: "",
      email: "Something went wrong - user was not added",
      password: "",
      pic: "",
      description: "",
    });
  };
  const { mutateAsync: addUser } = useCreateUserMutation({
    onSuccess: userAddedCallback,
    onError: failedAdditionCallBack,
  });
  const { mutateAsync: updateUser } = useUpdateUserMutation();
  const { mutateAsync: addClock } = useCreateClockMutation({
    onSuccess: successfulAdditionCallback,
    onError: failedAdditionCallBack,
  });
  const [countChar, setCountChar] = useState<number>();
  const [role, setRole] = useState("editor");
  // No default on purpose: whoever creates a clock must decide whether its
  // serial is test-only (reserved in the test serials file) or not.
  const [testSerial, setTestSerial] = useState<"" | "yes" | "no">("");
  const [testSerialError, setTestSerialError] = useState("");
  const [picURL, setPicURL] = useState<string>();
  const [imageUrl, setImageUrl] = useState("");
  const [loading, setLoading] = useState(false);
  const [loadPic, setLoadPic] = useState(false);

  const [error, setError] = useState({
    name: "",
    email: "",
    password: "",
    pic: "",
    description: "",
  });
  const formRef = useRef<HTMLFormElement>(null);

  const [country, setCountry] = useState("EA");
  const [state, setState] = useState("AL");
  const countrys = useMemo(() => {
    const r = countryList().getData();
    if (!r.find((c) => c.value === "EA")) {
      r.push({ value: "EA", label: "Earth" });
    }
    r.sort((a, b) => (a.label > b.label ? 1 : -1));
    return r;
  }, []);

  useEffect(() => {
    document.getElementById("newUserForm")?.setAttribute("class", "");
  }, [showAdd]);

  const handleSort = (field: keyof Author) => {
    setSortState((prev) => {
      const current = prev[field as string];
      if (current === 1) return { [field as string]: -1 as const };
      if (current === -1) return {};
      return { [field as string]: 1 as const };
    });
  };

  const displayData = useMemo(() => {
    if (!data) return [];
    let filtered: Author[] = artistsOnly
      ? data.filter((u) => u.type === UserType.ARTIST)
      : data;

    if (searchQuery) {
      const lowerVal = searchQuery.toLowerCase();
      filtered = filtered.filter((row) => {
        if (roles.includes(searchQuery)) return row.role === searchQuery;
        if (row?.tag === searchQuery) return true;
        return (
          row.name?.toLowerCase()?.includes(lowerVal) ||
          row.email?.toLowerCase()?.includes(lowerVal) ||
          row.id.toLowerCase().includes(lowerVal) ||
          row.role?.includes(searchQuery)
        );
      });
    }

    const [field, dir] = Object.entries(sortState)[0] || [];
    if (!field || !dir) return filtered;

    return [...filtered].sort((a, b) => {
      const av = a[field as keyof Author];
      const bv = b[field as keyof Author];
      if (av == null && bv == null) return 0;
      if (av == null) return 1;
      if (bv == null) return -1;
      if (typeof av === "number" && typeof bv === "number")
        return (av - bv) * dir;
      if (av instanceof Date && bv instanceof Date)
        return (av.getTime() - bv.getTime()) * dir;
      return String(av).localeCompare(String(bv)) * (dir as number);
    });
  }, [data, sortState, artistsOnly, searchQuery]);

  function resetAll() {
    setName("");
    setEmail("");
    setPassword("");
    setRole("editor");
    setTestSerial("");
    setTestSerialError("");
    setDescription("");
    setSocialNetworkList([]);
    setCreateCollaborator(false);
    setPicURL("");
    setCountry("IL");
    setState("AL");
    setLoading(false);
    setError({ name: "", email: "", password: "", pic: "", description: "" });
    setShowAdd(false);
  }

  function checkEmail(e: string) {
    const nameAndDomaian = e.split("@");
    if (nameAndDomaian.length !== 2) return false;
    if (nameAndDomaian[0] === "" || nameAndDomaian[1] === "") return false;
    const dom = nameAndDomaian[1].split(".");
    if (dom.length < 2 || dom.length > 3) return false;
    if (dom.reduce((p, c) => (p = p ? true : c === ""), false)) return false;
    return true;
  }

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const form = event.currentTarget;
    const err = { name: "", email: "", password: "", pic: "", description: "" };
    const testSerialMissing = role === "clock" && testSerial === "";
    setTestSerialError(
      testSerialMissing ? "Choose whether this is a test serial" : "",
    );
    if (testSerialMissing || !form.checkValidity()) {
      if (name === "") err.name = "Please enter a name";
      if (role !== "clock" && !checkEmail(email))
        err.email = "Please enter a valid email";
      if (password.length < 8)
        err.password = "Please enter a pasword with 8 or more characters";
      if (description.length > descriptionMaxLength)
        err.description = `Max length is ${descriptionMaxLength} charecters`;
      setError(err);
      event.stopPropagation();
    } else {
      setError(err);
      setLoading(true);
      if (role === "clock") {
        addClock({ serial: email, testSerial: testSerial === "yes" }).catch(
          (e) => {
            setLoading(false);
            console.log("e:", e);
            setError({
              name: "",
              email: extractApiErrorMessage(
                e,
                "Something went wrong - clock was not added",
              ),
              password: "",
              pic: "",
              description: "",
            });
          },
        );
      } else {
        addUser({
          name: name,
          email: email,
          password: password,
          role: role,
          country: country,
          state: state,
          description: description,
          socialMedia: socialNetworkList,
          photoUrl: imageUrl,
          createCollaborator,
        });
      }
    }
  };

  const buildTableRows = (r: Author, cols: Column<Author>[]) => (
    <>
      {cols.map((col) => (
        <DSTableCell key={col.field as string}>
          {col.field === "photoUrl" ? (
            r.role === "clock" ? (
              <img
                style={{ borderRadius: "50%" }}
                loading="lazy"
                height={40}
                width={40}
                alt="profile"
                src={clock_profile}
              />
            ) : (
              <img
                style={{ borderRadius: "50%" }}
                loading="lazy"
                height={40}
                width={40}
                alt="profile"
                src={r.photoUrl ?? anonymousPhoto}
              />
            )
          ) : col.field === "tag" ? (
            <div onClick={(e) => e.stopPropagation()}>
              <Editable
                title="tag"
                default={r?.tag || ""}
                onSet={(value) => updateUser({ id: r.id, tag: value })}
              />
            </div>
          ) : col.field === "featured" ? (
            r.featured ? (
              "Yes"
            ) : (
              ""
            )
          ) : col.field === "createdAt" ? (
            r.createdAt ? (
              new Date(r.createdAt).toLocaleDateString()
            ) : (
              ""
            )
          ) : col.field === "klydoCount" ? (
            String(r.klydoCount ?? 0)
          ) : col.field === "clocks" ? (
            String(r.clocks?.length ?? 0)
          ) : (
            String(r[col.field] ?? "")
          )}
        </DSTableCell>
      ))}
    </>
  );

  return (
    <>
      <PageHeader
        overline="People"
        title="Users"
        subtitle="Studio artists and platform accounts"
        actions={
          <DSPrimaryButton onClick={() => setShowAdd(true)}>
            Add User
          </DSPrimaryButton>
        }
      />
      <FilterBar
        search={{
          value: searchQuery,
          onChange: setSearchQuery,
          placeholder: "Search users...",
        }}
        activeCount={
          (artistsOnly ? 1 : 0) +
          (hasClockOnly ? 1 : 0) +
          (manualPayoutOnly ? 1 : 0) +
          (hasCollectionOnly ? 1 : 0)
        }
      >
        <DSFormControlLabel
          control={
            <DSCheckBox
              checked={artistsOnly}
              onChange={(e) => setArtistsOnly(e.target.checked)}
            />
          }
          label="Artists Only"
        />
        <DSFormControlLabel
          control={
            <DSCheckBox
              checked={hasClockOnly}
              onChange={(e) => setHasClockOnly(e.target.checked)}
            />
          }
          label="Has Clock"
        />
        <DSFormControlLabel
          control={
            <DSCheckBox
              checked={manualPayoutOnly}
              onChange={(e) => setManualPayoutOnly(e.target.checked)}
            />
          }
          label="Manual Payout"
        />
        <DSFormControlLabel
          control={
            <DSCheckBox
              checked={hasCollectionOnly}
              onChange={(e) => setHasCollectionOnly(e.target.checked)}
            />
          }
          label="Has Collection"
        />
      </FilterBar>

      {collaboratorWarning && (
        <DSAlert
          severity="warning"
          onClose={() => setCollaboratorWarning(null)}
          sx={{ mb: 2 }}
        >
          {collaboratorWarning}
        </DSAlert>
      )}

      {data && !isLoading ? (
        <DSBaseTable
          data={displayData}
          columns={tableColumns}
          rowBuilder={buildTableRows}
          onPressRow={(row) => setChosenUser(row)}
          onSort={handleSort}
          sortState={sortState}
          getRowId={(row) => row.id}
          confirmDelete={false}
          onPressDelete={(row) => setUserToDelete(row)}
        />
      ) : (
        <DSCircularProgress />
      )}

      {chosenUser && (
        <DSDialog
          fullWidth
          maxWidth="lg"
          open={!!chosenUser}
          onClose={() => setChosenUser(undefined)}
        >
          <UserModal
            row={chosenUser}
            klydos={[]}
            setShowModal={() => setChosenUser(undefined)}
          />
        </DSDialog>
      )}

      <DeleteUserModal
        user={userToDelete}
        onClose={() => setUserToDelete(null)}
      />

      <DSDialog
        open={showAdd}
        onClose={resetAll}
        fullWidth
        maxWidth="md"
        fullScreen={isSmallTablet}
      >
        <DSDialogTitle
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          Add a new user
          <DSIconButton aria-label="Close" onClick={resetAll}>
            <CloseIcon />
          </DSIconButton>
        </DSDialogTitle>
        <DSDialogContent>
          {role !== "clock" && (
            <div
              style={{
                width: "100%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <div
                style={{
                  width: 200,
                  height: 200,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <span style={{ position: "absolute" }}>
                  {loadPic ? (
                    <DSCircularProgress />
                  ) : (
                    <img
                      referrerPolicy="no-referrer"
                      style={{ borderRadius: 50 + "%" }}
                      loading="eager"
                      height={150}
                      width={150}
                      alt="profile"
                      src={picURL || place_holder}
                    />
                  )}
                </span>
                <div style={{ height: 15, width: 15 }}></div>
                <input
                  id="user-photo"
                  onChange={(e) => {
                    setLoadPic(true);
                    const fr = new FileReader();
                    fr.onload = function () {
                      setLoadPic(false);
                      setPicURL(fr.result as string);
                    };
                    const file = e.target.files![0];
                    if (!file) return;
                    fr.readAsDataURL(file);
                    setTimeout(() => {
                      const url =
                        "https://api.cloudinary.com/v1_1/KlydoClock/image/upload";
                      const formData = new FormData();
                      formData.append("file", file);
                      formData.append("folder", "profile");
                      formData.append("upload_preset", "Bezalel_preset");
                      return fetch(url, {
                        method: "POST",
                        body: formData,
                      })
                        .then((response) => {
                          return response.json();
                        })
                        .then((res) => {
                          const img = res.secure_url;
                          if (img) {
                            setImageUrl(img);
                          }
                        })
                        .catch((e) => {
                          console.log("e:", e);
                          const allErr = error;
                          allErr.pic = e.toLocaleString();
                          setError(allErr);
                        });
                    }, 0);
                  }}
                  type="file"
                  style={{ width: 100 + "%", height: 100 + "%", opacity: 0 }}
                />
              </div>
            </div>
          )}

          <form
            noValidate
            data-validated={validated}
            onSubmit={handleSubmit}
            ref={formRef}
            id="newUserForm"
          >
            <DSBox
              sx={{
                display: "grid",
                gridTemplateColumns: { xxs: "1fr", sm: "1fr 1fr" },
                gap: 2,
              }}
            >
              {role === "clock" ? (
                <DSBox
                  sx={{
                    height: "100%",
                    display: "flex",
                    alignItems: "center",
                    pb: "0.5rem",
                  }}
                >
                  <DSTypography>Clock</DSTypography>
                </DSBox>
              ) : (
                <DSTextField
                  label="Name"
                  error={error.name !== ""}
                  helperText={error.name}
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  type="name"
                  placeholder="Enter name"
                  required
                  fullWidth
                />
              )}
              <DSTextField
                select
                label="Role"
                fullWidth
                value={role}
                onChange={(e) => {
                  setRole(e.target.value);
                }}
              >
                {roles.map((s) => (
                  <DSMenuItem key={s} value={s}>
                    {s}
                  </DSMenuItem>
                ))}
              </DSTextField>
            </DSBox>
            <DSBox
              sx={{ display: "flex", alignItems: "center", pt: 2.5, gap: 1 }}
            >
              <DSTextField
                label="Email address"
                error={error.email !== ""}
                helperText={error.email}
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                type={role === "clock" ? "name" : "email"}
                placeholder="Enter email"
                required
                sx={{ width: role === "clock" ? "50%" : "100%" }}
              />
              {role === "clock" && <DSTypography>@clocks.com</DSTypography>}
            </DSBox>
            {role === "clock" ? (
              <>
                <b>Auto password</b>
                <DSTextField
                  select
                  required
                  label="Test serial?"
                  fullWidth
                  sx={{ mt: 2.5 }}
                  value={testSerial}
                  error={testSerialError !== ""}
                  helperText={
                    testSerialError ||
                    "Yes records the serial in the test serials file, so production generation never issues it or its friendly identifier. No requires a serial from a generated batch."
                  }
                  onChange={(e) => {
                    setTestSerial(e.target.value as "yes" | "no");
                    setTestSerialError("");
                  }}
                >
                  <DSMenuItem value="yes">
                    Yes — test serial, add it to the test serials file
                  </DSMenuItem>
                  <DSMenuItem value="no">
                    No — production serial from a generated batch
                  </DSMenuItem>
                </DSTextField>
              </>
            ) : (
              <DSBox sx={{ display: "flex", pt: 2.5 }}>
                <DSTextField
                  label="Password"
                  fullWidth
                  error={error.password !== ""}
                  helperText={error.password}
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  type="password"
                  placeholder="Password"
                  required
                  disabled={role === "clock"}
                />
              </DSBox>
            )}
            {role === "editor" && (
              <DSBox sx={{ pt: 2.5 }}>
                <DSFormControlLabel
                  control={
                    <DSCheckBox
                      checked={createCollaborator}
                      onChange={(e) => setCreateCollaborator(e.target.checked)}
                    />
                  }
                  label="Create CollabPay collaborator"
                />
                <DSTypography
                  sx={{ fontSize: "12px", color: "text.secondary" }}
                >
                  Required for an account that will own marketplace collections
                  — the publication pass skips collections whose creator has no
                  collaborator.
                </DSTypography>
              </DSBox>
            )}
            {role === "editor" && (
              <SocialNetworkEdit
                list={socialNetworkList}
                onChange={(list: SocialNetwork[]) => setSocialNetworkList(list)}
              ></SocialNetworkEdit>
            )}
            {role === "editor" ? (
              <>
                <DSTextField
                  select
                  label="Country"
                  fullWidth
                  sx={{ mt: 2.5 }}
                  value={country}
                  onChange={(e) => {
                    setCountry(e.target.value);
                  }}
                >
                  {countrys.map((s: { value: string; label: string }) => (
                    <DSMenuItem key={s.value} value={s.value}>
                      {s.label}
                    </DSMenuItem>
                  ))}
                </DSTextField>
                {country === "US" ? (
                  <>
                    <DSTextField
                      select
                      label="State"
                      fullWidth
                      sx={{ mt: 2.5 }}
                      value={state}
                      onChange={(e) => {
                        setState(e.target.value);
                      }}
                    >
                      {statesList.map((s: { value: string; label: string }) => (
                        <DSMenuItem key={s.value} value={s.value}>
                          {s.label}
                        </DSMenuItem>
                      ))}
                    </DSTextField>
                  </>
                ) : (
                  <></>
                )}
                <DSBox
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    mt: 2.5,
                  }}
                >
                  <DSTextField
                    label="Description"
                    multiline
                    rows={6}
                    fullWidth
                    value={description}
                    error={error.description !== ""}
                    helperText={error.description}
                    inputProps={{ maxLength: descriptionMaxLength }}
                    onChange={(e) => {
                      setDescription(e.target.value);
                      setCountChar(
                        descriptionMaxLength - e.target.value.length,
                      );
                    }}
                  />
                  {countChar === undefined ? (
                    <></>
                  ) : (
                    <DSTypography
                      sx={{
                        color: countChar <= 10 ? "error.main" : "success.main",
                        fontSize: "10px",
                      }}
                    >
                      characters left: {countChar}
                    </DSTypography>
                  )}
                </DSBox>
              </>
            ) : (
              <></>
            )}
            <DSBox
              sx={{ display: "flex", justifyContent: "flex-end", mt: 2.5 }}
            >
              <DSPrimaryButton title="add" type="submit">
                <>
                  {loading ? (
                    <DSCircularProgress size={20} sx={{ mr: 1 }} />
                  ) : (
                    <></>
                  )}
                  add
                </>
              </DSPrimaryButton>
            </DSBox>
          </form>
        </DSDialogContent>
      </DSDialog>
    </>
  );
}

export default Users;
